import { Navigate, Outlet, useLocation } from "react-router-dom";

const FlowProtectedRoute = () => {
  const location = useLocation();

  const isAllowed = location?.state?.phone;

  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default FlowProtectedRoute;
